import { createAsyncThunk } from "@reduxjs/toolkit";
import { Config } from "../../config";
import { axiosConfig } from "../../utils/util.fns";
import axios from "axios";

export const getOneResultDetails = createAsyncThunk("resultDetail/getOne", async (resultId: number) => {
	const response = await axios.get(Config.apiSecureUrl + `/result/${resultId}`, axiosConfig());
	return response.data;
});
